/**
 * Offline-ish geocoding for community “where from” map pins.
 * Uses country / US-state / major-city centroids — no street addresses.
 */

// Approximate country centroids [lat, lng]
const COUNTRIES = {
  afghanistan: [33.9, 67.7],
  albania: [41.2, 20.2],
  algeria: [28.0, 1.7],
  argentina: [-38.4, -63.6],
  armenia: [40.1, 45.0],
  australia: [-25.3, 133.8],
  austria: [47.5, 14.6],
  azerbaijan: [40.1, 47.6],
  bahrain: [26.0, 50.6],
  bangladesh: [23.7, 90.4],
  belarus: [53.7, 27.9],
  belgium: [50.5, 4.5],
  belize: [17.2, -88.5],
  bolivia: [-16.3, -63.6],
  'bosnia and herzegovina': [43.9, 17.7],
  bosnia: [43.9, 17.7],
  brazil: [-14.2, -51.9],
  bulgaria: [42.7, 25.5],
  cambodia: [12.6, 105.0],
  cameroon: [7.4, 12.4],
  canada: [56.1, -106.3],
  chile: [-35.7, -71.5],
  china: [35.9, 104.2],
  colombia: [4.6, -74.3],
  'costa rica': [9.7, -83.8],
  croatia: [45.1, 15.2],
  cuba: [21.5, -77.8],
  cyprus: [35.1, 33.4],
  'czech republic': [49.8, 15.5],
  czechia: [49.8, 15.5],
  denmark: [56.3, 9.5],
  'dominican republic': [18.7, -70.2],
  ecuador: [-1.8, -78.2],
  egypt: [26.8, 30.8],
  'el salvador': [13.8, -88.9],
  estonia: [58.6, 25.0],
  ethiopia: [9.1, 40.5],
  finland: [61.9, 25.7],
  france: [46.2, 2.2],
  georgia: [42.3, 43.4],
  germany: [51.2, 10.5],
  ghana: [7.9, -1.0],
  greece: [39.1, 21.8],
  guatemala: [15.8, -90.2],
  honduras: [15.2, -86.2],
  'hong kong': [22.3, 114.2],
  hungary: [47.2, 19.5],
  iceland: [64.9, -19.0],
  india: [20.6, 78.9],
  indonesia: [-0.8, 113.9],
  iran: [32.4, 53.7],
  iraq: [33.2, 43.7],
  ireland: [53.1, -8.2],
  israel: [31.0, 34.9],
  italy: [41.9, 12.6],
  jamaica: [18.1, -77.3],
  japan: [36.2, 138.3],
  jordan: [30.6, 36.2],
  kazakhstan: [48.0, 66.9],
  kenya: [-0.0, 37.9],
  kuwait: [29.3, 47.5],
  latvia: [56.9, 24.6],
  lebanon: [33.9, 35.9],
  lithuania: [55.2, 23.9],
  luxembourg: [49.8, 6.1],
  malaysia: [4.2, 101.9],
  mexico: [23.6, -102.5],
  moldova: [47.4, 28.4],
  mongolia: [46.9, 103.8],
  morocco: [31.8, -7.1],
  nepal: [28.4, 84.1],
  netherlands: [52.1, 5.3],
  'new zealand': [-40.9, 174.9],
  nicaragua: [12.9, -85.2],
  nigeria: [9.1, 8.7],
  'north macedonia': [41.6, 21.7],
  norway: [60.5, 8.5],
  oman: [21.5, 55.9],
  pakistan: [30.4, 69.3],
  panama: [8.5, -80.8],
  paraguay: [-23.4, -58.4],
  peru: [-9.2, -75.0],
  philippines: [12.9, 121.8],
  poland: [51.9, 19.1],
  portugal: [39.4, -8.2],
  'puerto rico': [18.2, -66.6],
  qatar: [25.4, 51.2],
  romania: [45.9, 24.9],
  russia: [61.5, 105.3],
  'saudi arabia': [23.9, 45.1],
  scotland: [56.5, -4.2],
  serbia: [44.0, 21.0],
  singapore: [1.4, 103.8],
  slovakia: [48.7, 19.7],
  slovenia: [46.2, 14.9],
  'south africa': [-30.6, 22.9],
  'south korea': [35.9, 127.8],
  korea: [35.9, 127.8],
  spain: [40.5, -3.7],
  'sri lanka': [7.9, 80.8],
  sweden: [60.1, 18.6],
  switzerland: [46.8, 8.2],
  taiwan: [23.7, 120.9],
  thailand: [15.9, 100.9],
  'trinidad and tobago': [10.7, -61.2],
  tunisia: [33.9, 9.5],
  turkey: [38.9, 35.2],
  türkiye: [38.9, 35.2],
  ukraine: [48.4, 31.2],
  'united arab emirates': [23.4, 53.8],
  uae: [23.4, 53.8],
  'united kingdom': [55.4, -3.4],
  uk: [55.4, -3.4],
  england: [52.4, -1.2],
  wales: [52.1, -3.8],
  'united states': [39.8, -98.6],
  usa: [39.8, -98.6],
  us: [39.8, -98.6],
  'u.s.': [39.8, -98.6],
  'u.s.a.': [39.8, -98.6],
  america: [39.8, -98.6],
  uruguay: [-32.5, -55.8],
  venezuela: [6.4, -66.6],
  vietnam: [14.1, 108.3],
  zimbabwe: [-19.0, 29.2]
}

// US state centroids + common abbreviations
const US_STATES = {
  alabama: [32.8, -86.8], al: [32.8, -86.8],
  alaska: [64.2, -149.5], ak: [64.2, -149.5],
  arizona: [34.0, -111.1], az: [34.0, -111.1],
  arkansas: [34.9, -92.4], ar: [34.9, -92.4],
  california: [36.8, -119.4], ca: [36.8, -119.4],
  colorado: [39.1, -105.3], co: [39.1, -105.3],
  connecticut: [41.6, -72.8], ct: [41.6, -72.8],
  delaware: [39.0, -75.5], de: [39.0, -75.5],
  florida: [27.8, -81.7], fl: [27.8, -81.7],
  georgia: [32.2, -83.5], ga: [32.2, -83.5],
  hawaii: [19.9, -155.6], hi: [19.9, -155.6],
  idaho: [44.2, -114.5], id: [44.2, -114.5],
  illinois: [40.3, -89.0], il: [40.3, -89.0],
  indiana: [39.8, -86.1], in: [39.8, -86.1],
  iowa: [42.0, -93.2], ia: [42.0, -93.2],
  kansas: [38.5, -98.5], ks: [38.5, -98.5],
  kentucky: [37.7, -84.7], ky: [37.7, -84.7],
  louisiana: [31.2, -91.9], la: [31.2, -91.9],
  maine: [45.3, -69.4], me: [45.3, -69.4],
  maryland: [39.1, -76.8], md: [39.1, -76.8],
  massachusetts: [42.2, -71.5], ma: [42.2, -71.5],
  michigan: [43.3, -84.5], mi: [43.3, -84.5],
  minnesota: [46.7, -94.7], mn: [46.7, -94.7],
  mississippi: [32.7, -89.7], ms: [32.7, -89.7],
  missouri: [38.5, -92.3], mo: [38.5, -92.3],
  montana: [47.1, -109.6], mt: [47.1, -109.6],
  nebraska: [41.1, -98.3], ne: [41.1, -98.3],
  nevada: [38.4, -117.1], nv: [38.4, -117.1],
  'new hampshire': [43.5, -71.6], nh: [43.5, -71.6],
  'new jersey': [40.1, -74.4], nj: [40.1, -74.4],
  'new mexico': [34.5, -106.0], nm: [34.5, -106.0],
  'new york': [42.2, -74.9], ny: [42.2, -74.9],
  'north carolina': [35.6, -79.4], nc: [35.6, -79.4],
  'north dakota': [47.5, -100.0], nd: [47.5, -100.0],
  ohio: [40.4, -82.8], oh: [40.4, -82.8],
  oklahoma: [35.5, -97.5], ok: [35.5, -97.5],
  oregon: [43.8, -120.6], or: [43.8, -120.6],
  pennsylvania: [40.9, -77.2], pa: [40.9, -77.2],
  'rhode island': [41.7, -71.5], ri: [41.7, -71.5],
  'south carolina': [33.9, -80.9], sc: [33.9, -80.9],
  'south dakota': [44.3, -99.9], sd: [44.3, -99.9],
  tennessee: [35.7, -86.6], tn: [35.7, -86.6],
  texas: [31.0, -99.9], tx: [31.0, -99.9],
  utah: [39.3, -111.1], ut: [39.3, -111.1],
  vermont: [44.0, -72.7], vt: [44.0, -72.7],
  virginia: [37.4, -78.7], va: [37.4, -78.7],
  washington: [47.4, -120.5], wa: [47.4, -120.5],
  'west virginia': [38.5, -80.9], wv: [38.5, -80.9],
  wisconsin: [44.3, -89.6], wi: [44.3, -89.6],
  wyoming: [43.1, -107.3], wy: [43.1, -107.3],
  'district of columbia': [38.9, -77.0], dc: [38.9, -77.0],
  'washington dc': [38.9, -77.0],
  'washington d.c.': [38.9, -77.0]
}

// Major cities [lat, lng] — improves pins beyond country centroid
const CITIES = {
  // US
  'new york': [40.71, -74.01], nyc: [40.71, -74.01], manhattan: [40.78, -73.97],
  brooklyn: [40.68, -73.94],
  'los angeles': [34.05, -118.24], la: [34.05, -118.24],
  chicago: [41.88, -87.63],
  houston: [29.76, -95.37],
  phoenix: [33.45, -112.07],
  philadelphia: [39.95, -75.17],
  'san antonio': [29.42, -98.49],
  'san diego': [32.72, -117.16],
  dallas: [32.78, -96.8],
  'san jose': [37.34, -121.89],
  austin: [30.27, -97.74],
  jacksonville: [30.33, -81.66],
  'fort worth': [32.76, -97.33],
  columbus: [39.96, -83.0],
  charlotte: [35.23, -80.84],
  'san francisco': [37.77, -122.42],
  indianapolis: [39.77, -86.16],
  seattle: [47.61, -122.33],
  denver: [39.74, -104.99],
  washington: [38.91, -77.04],
  boston: [42.36, -71.06],
  nashville: [36.16, -86.78],
  detroit: [42.33, -83.05],
  'oklahoma city': [35.47, -97.52],
  portland: [45.52, -122.68],
  'las vegas': [36.17, -115.14],
  memphis: [35.15, -90.05],
  louisville: [38.25, -85.76],
  baltimore: [39.29, -76.61],
  milwaukee: [43.04, -87.91],
  albuquerque: [35.08, -106.65],
  tucson: [32.22, -110.97],
  fresno: [36.74, -119.79],
  sacramento: [38.58, -121.49],
  atlanta: [33.75, -84.39],
  miami: [25.76, -80.19],
  orlando: [28.54, -81.38],
  tampa: [27.95, -82.46],
  'st. petersburg': [27.77, -82.64],
  'st petersburg': [27.77, -82.64],
  'new smyrna beach': [29.03, -80.93],
  'daytona beach': [29.21, -81.02],
  minneapolis: [44.98, -93.27],
  cleveland: [41.5, -81.69],
  'kansas city': [39.1, -94.58],
  'salt lake city': [40.76, -111.89],
  raleigh: [35.78, -78.64],
  richmond: [37.54, -77.44],
  pittsburgh: [40.44, -79.99],
  cincinnati: [39.1, -84.51],
  'st. louis': [38.63, -90.2],
  'st louis': [38.63, -90.2],
  'new orleans': [29.95, -90.07],
  honolulu: [21.31, -157.86],
  anchorage: [61.22, -149.9],
  // Canada
  toronto: [43.65, -79.38],
  montreal: [45.5, -73.57],
  vancouver: [49.28, -123.12],
  calgary: [51.05, -114.07],
  ottawa: [45.42, -75.7],
  edmonton: [53.55, -113.49],
  // UK / Europe
  london: [51.51, -0.13],
  manchester: [53.48, -2.24],
  edinburgh: [55.95, -3.19],
  paris: [48.86, 2.35],
  lyon: [45.76, 4.84],
  berlin: [52.52, 13.41],
  munich: [48.14, 11.58],
  hamburg: [53.55, 9.99],
  amsterdam: [52.37, 4.9],
  brussels: [50.85, 4.35],
  madrid: [40.42, -3.7],
  barcelona: [41.39, 2.17],
  rome: [41.9, 12.5],
  milan: [45.46, 9.19],
  vienna: [48.21, 16.37],
  zurich: [47.38, 8.54],
  geneva: [46.2, 6.14],
  stockholm: [59.33, 18.07],
  oslo: [59.91, 10.75],
  copenhagen: [55.68, 12.57],
  dublin: [53.35, -6.26],
  lisbon: [38.72, -9.14],
  prague: [50.08, 14.44],
  budapest: [47.5, 19.04],
  warsaw: [52.23, 21.01],
  athens: [37.98, 23.73],
  istanbul: [41.01, 28.98],
  // LatAm
  'mexico city': [19.43, -99.13],
  guadalajara: [20.66, -103.35],
  monterrey: [25.69, -100.32],
  'buenos aires': [-34.6, -58.38],
  'sao paulo': [-23.55, -46.63],
  'são paulo': [-23.55, -46.63],
  'rio de janeiro': [-22.91, -43.17],
  bogota: [4.71, -74.07],
  bogotá: [4.71, -74.07],
  lima: [-12.05, -77.04],
  santiago: [-33.45, -70.67],
  // Asia / Oceania / Middle East / Africa
  tokyo: [35.68, 139.69],
  osaka: [34.69, 135.5],
  seoul: [37.57, 126.98],
  beijing: [39.9, 116.4],
  shanghai: [31.23, 121.47],
  'hong kong': [22.32, 114.17],
  singapore: [1.35, 103.82],
  bangkok: [13.76, 100.5],
  manila: [14.6, 120.98],
  jakarta: [-6.21, 106.85],
  mumbai: [19.08, 72.88],
  delhi: [28.61, 77.21],
  'new delhi': [28.61, 77.21],
  bangalore: [12.97, 77.59],
  bengaluru: [12.97, 77.59],
  dubai: [25.2, 55.27],
  'abu dhabi': [24.45, 54.38],
  tel: [32.09, 34.78], // partial
  'tel aviv': [32.09, 34.78],
  jerusalem: [31.77, 35.21],
  cairo: [30.04, 31.24],
  lagos: [6.52, 3.38],
  nairobi: [-1.29, 36.82],
  'cape town': [-33.92, 18.42],
  johannesburg: [-26.2, 28.05],
  sydney: [-33.87, 151.21],
  melbourne: [-37.81, 144.96],
  brisbane: [-27.47, 153.03],
  perth: [-31.95, 115.86],
  auckland: [-36.85, 174.76],
  wellington: [-41.29, 174.78]
}

function normalize (s) {
  return String(s || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[’']/g, "'")
    .replace(/[^a-z0-9.,\s\-']/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
}

/**
 * @param {string} raw free-text “coming from”
 * @returns {{ lat: number, lng: number, label: string, precision: 'city'|'region'|'country' } | null}
 */
export function geocodeComingFrom (raw) {
  const label = String(raw || '').trim()
  if (!label) {
    return null
  }
  const text = normalize(label)
  if (!text) {
    return null
  }

  // Split on comma / slash / " - "
  const parts = text.split(/[,/|]| - /).map(p => p.trim()).filter(Boolean)

  // Try full string as city first
  if (CITIES[text]) {
    const [lat, lng] = CITIES[text]
    return { lat, lng, label, precision: 'city' }
  }

  // City in first segment, optional region/country after
  if (parts.length >= 1 && CITIES[parts[0]]) {
    const [lat, lng] = CITIES[parts[0]]
    return { lat, lng, label, precision: 'city' }
  }

  // "City ST" or "City, ST"
  for (const part of parts) {
    const m = part.match(/^(.+?)\s+([a-z]{2})$/)
    if (m && CITIES[m[1]] && US_STATES[m[2]]) {
      const [lat, lng] = CITIES[m[1]]
      return { lat, lng, label, precision: 'city' }
    }
    if (m && US_STATES[m[2]] && !CITIES[m[1]]) {
      // Unknown city but known state — use state centroid with slight city hash offset later
      const [lat, lng] = US_STATES[m[2]]
      return { lat, lng, label, precision: 'region' }
    }
  }

  // US state full name or abbr in any part
  for (const part of parts) {
    if (US_STATES[part]) {
      const [lat, lng] = US_STATES[part]
      return { lat, lng, label, precision: 'region' }
    }
  }
  // "... Texas" trailing state in single string
  for (const key of Object.keys(US_STATES)) {
    if (key.length > 2 && (text.endsWith(' ' + key) || text.includes(key + ',') || text === key)) {
      const [lat, lng] = US_STATES[key]
      return { lat, lng, label, precision: 'region' }
    }
  }

  // Country match (prefer longer names)
  const countryKeys = Object.keys(COUNTRIES).sort((a, b) => b.length - a.length)
  for (const key of countryKeys) {
    if (text === key || text.endsWith(' ' + key) || text.includes(key + ',') || parts.includes(key)) {
      const [lat, lng] = COUNTRIES[key]
      return { lat, lng, label, precision: 'country' }
    }
  }

  // Last segment country / first segment city scan
  for (const part of parts) {
    if (CITIES[part]) {
      const [lat, lng] = CITIES[part]
      return { lat, lng, label, precision: 'city' }
    }
  }

  return null
}

/**
 * Small deterministic offset so stacked pins fan out.
 * @param {number} lat
 * @param {number} lng
 * @param {number} index
 * @param {number} total
 */
export function offsetPin (lat, lng, index, total) {
  if (total <= 1) {
    return { lat, lng }
  }
  const angle = (index / total) * Math.PI * 2
  const r = 0.35 + (index % 3) * 0.12
  return {
    lat: lat + Math.sin(angle) * r,
    lng: lng + Math.cos(angle) * r
  }
}

/**
 * Build map pins from community intro cards.
 * @param {Array<{ id: string, comingFrom?: string, displayName?: string, firstName?: string, lastName?: string, headshotUrl?: string }>} intros
 */
export function pinsFromIntros (intros) {
  const list = Array.isArray(intros) ? intros : []
  const raw = []
  for (const card of list) {
    const comingFrom = String((card && card.comingFrom) || '').trim()
    if (!comingFrom) {
      continue
    }
    const geo = geocodeComingFrom(comingFrom)
    if (!geo) {
      continue
    }
    const name = (card.displayName ||
      `${card.firstName || ''} ${card.lastName || ''}`.trim() ||
      'Dancer')
    raw.push({
      id: card.id,
      name,
      comingFrom,
      isFaculty: !!(card && (card.isFaculty || card.personType === 'faculty')),
      headshotUrl: card.headshotUrl || '',
      lat: geo.lat,
      lng: geo.lng,
      precision: geo.precision,
      key: `${geo.lat.toFixed(2)},${geo.lng.toFixed(2)}`
    })
  }

  // Group co-located pins and offset
  const groups = {}
  raw.forEach(p => {
    if (!groups[p.key]) {
      groups[p.key] = []
    }
    groups[p.key].push(p)
  })

  const pins = []
  Object.keys(groups).forEach(key => {
    const g = groups[key]
    g.forEach((p, i) => {
      const o = offsetPin(p.lat, p.lng, i, g.length)
      pins.push({
        ...p,
        lat: o.lat,
        lng: o.lng,
        clusterSize: g.length
      })
    })
  })
  return pins
}

export function countUnmapped (intros) {
  const list = Array.isArray(intros) ? intros : []
  let n = 0
  list.forEach(card => {
    const comingFrom = String((card && card.comingFrom) || '').trim()
    if (comingFrom && !geocodeComingFrom(comingFrom)) {
      n++
    }
  })
  return n
}
